import React, { useEffect, useState } from 'react'
import { Container, Typography } from '@material-ui/core';
import { getImportCsvRecordsForAccount } from "../../../../services/backendApi";
import { useInterval } from '../../../hooks/useInterval'
import { StatusMap } from '../../../../enum/ImportZones'
import { useDropZoneState, useDropZoneDispatch } from '../../../contexts/drop-zone-context'
import RecentImportsTable from './RecentImportsTable'

const RecentImports = ({ accountId, deleteFile }) => {
    const INTERVAL_DELAY = 5000 // 5 seconds
    const { filesList, requiresFilesUpdate } = useDropZoneState()
    const { updateFiles } = useDropZoneDispatch()
    const [ isZonesCreationInProgress, setIsZonesCreationInProgress ] = useState(true)

    useEffect(() => {
        setIsZonesCreationInProgress(filesList.some(file => file.status === StatusMap.PROCESSING.status || file.status === StatusMap.APPROVED.status))
    }, [filesList])

    useEffect(() => {
        if (requiresFilesUpdate) getFilesList()
    }, [ requiresFilesUpdate ])

    useInterval(() => getFilesList(), isZonesCreationInProgress ? INTERVAL_DELAY : null )

    const getFilesList = async () => {
        try { 
            const filesData = await getImportCsvRecordsForAccount(accountId)
            updateFiles(filesData.Items)
        } catch (error) {
            console.log('error', error)
            alert('There was an issue retreiving list of CSV files')
        }
    }

    return (
        <Container maxWidth="xl" className="white-card list-container">
            <h5 className="title">RECENT IMPORTS</h5>
            { 
                filesList.filter(file => file.status !== StatusMap.COMPLETED.status).length ? 
                    <RecentImportsTable deleteFile={deleteFile} accountId={accountId}/> :
                    <Typography variant="subtitle1">You haven’t imported any files yet. Drag and drop a CSV file to start the upload</Typography>  
            }
        </Container>
    )
}

export default RecentImports